import PageMeta from "../../components/common/PageMeta";
import GeneralReqs from "../../components/hotel/GeneralReqs";

export default function Housekeeping() {
  return (
    <>
      <PageMeta
        title="General Requests - SelfServe"
        description="SelfServe General Requests Dashboard"
      />
      <div className="col-span-12">
        <GeneralReqs />
      </div>
    </>
  );
}
